// @ts-nocheck
import React from 'react';
import {Card, Input, Select, DatePicker, Button, Row, Col, message} from 'antd';
import {Formik, Form, ErrorMessage} from 'formik';
import {initialValues} from './schema';
import Item from '../../components/Form/Item';
import {HEALTH_STATUS, IDENTITY_TYPE} from './options';
import SkillsForm from './SkillsForm';
import SicknessForm from './SicknessForm';
import moment from 'moment';
import UploadSkillsFile from './UploadSkillsFile';
import ProjectForm from './ProjectForm';
import {Link, useHistory} from 'react-router-dom';
import axios from '../../util/Api';
import VendorDetail from './VendorDetail';
import {registerSchema} from './schema';
import EducationForm from './EducationForm';
import DepartmentForm from './DepartmentForm';
import PositionForm from './PositionForm';
import UploadButton from './UploadButton';
import JobSpecializationForm from './JobSpecializationForm';
import TrainingCompetencyForm from './TrainingCompetencyForm';

const {Option} = Select;
const {TextArea} = Input;

const Create = (props) => {
  const history = useHistory();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={registerSchema}
      onSubmit={(values, {setSubmitting}) => {
        const hasSkillsFileError =
          Array.isArray(values.skills_file) &&
          values.skills_file.some((cert) => Boolean(cert && cert.error));
        if (hasSkillsFileError) {
          message.error('Terdapat file yang melebihi batas ukuran maksimal. Harap perbaiki sebelum menyimpan.');
          setSubmitting(false);
          return;
        }

        const url = `/passport/create`;
        const data = {...values};

        axios
          .post(url, data)
          .then((resp) => {
            if (resp.data.success) {
              message.success('Passport baru telah berhasil dibuat', 5);
              history.push(`/passport/detail?id=${resp.data.passport.id}&new_passport=true`);
            } else {
              message.error('Gagal menyimpan data personel baru');
              setSubmitting(false);
            }
          })
          .catch((err) => {
            setSubmitting(false);
            const resp = err.response;
            const messageText =
              resp?.data?.message || err.message || 'Gagal menyimpan data personel baru';
            message.error(messageText, 5);
          });
      }}
    >
      {(formik) => {
        const hasSkillsFileError =
          Array.isArray(formik.values.skills_file) &&
          formik.values.skills_file.some((cert) => Boolean(cert && cert.error));
        const hasFileError = hasSkillsFileError;

        return (
          <Form>
            <Card className="gx-card" title="Registrasi">
              <VendorDetail />
              <Item name="Nama" required>
                <Input name="name" onChange={formik.handleChange} autoFocus={true} />

                <ErrorMessage component="div" name="name" className="gx-mt-2 gx-text-red" />
              </Item>
              <Item name="Jenis Identitas" required>
                <Select
                  defaultValue={formik.values.identity.type}
                  onChange={(value) => formik.setFieldValue('identity.type', value)}
                  placeholder="Pilih jenis identitas"
                >
                  {IDENTITY_TYPE.map((identity, key) => {
                    return (
                      <Option value={identity.id} key={`identity-type-${key}`}>
                        {identity.label}
                      </Option>
                    );
                  })}
                </Select>
                <ErrorMessage
                  component="div"
                  name="identity.type"
                  className="gx-mt-2 gx-text-red"
                />
              </Item>
              <Item name="No Identitas Diri" required>
                <Row>
                  <Col md={12} xs={24}>
                    <Input name="identity.number" onChange={formik.handleChange} />
                    <ErrorMessage
                      component="div"
                      name="identity.number"
                      className="gx-mt-2 gx-text-red"
                    />
                  </Col>
                  <Col md={12} xs={24}>
                    {/* <UploadButton type="image" onDone={(files) => formik.setFieldValue("identity.file", files)} /> */}
                  </Col>
                </Row>
              </Item>
              <Item name="Kebangsaan" required>
                <Select
                  defaultValue={formik.values.nationality}
                  onChange={(value) => formik.setFieldValue('nationality', value)}
                  placeholder="Pilih kebangsaan"
                >
                  <Option value="wni">WNI</Option>
                  <Option value="wna">WNA</Option>
                </Select>
                <ErrorMessage component="div" name="nationality" className="gx-mt-2 gx-text-red" />
              </Item>
              <Item name="Jenis Kelamin" required>
                <Select
                  defaultValue={formik.values.gender}
                  onChange={(value) => formik.setFieldValue('gender', value)}
                  placeholder="Pilih jenis kelamin"
                >
                  <Option value="L">Laki-Laki</Option>
                  <Option value="P">Perempuan</Option>
                </Select>
                <ErrorMessage component="div" name="gender" className="gx-mt-2 gx-text-red" />
              </Item>
              <Item name="Golongan Darah" required>
                <Select
                  defaultValue={formik.values.blood_type}
                  onChange={(value) => formik.setFieldValue('blood_type', value)}
                  placeholder="Pilih golongan darah"
                >
                  <Option value="A">A</Option>
                  <Option value="B">B</Option>
                  <Option value="O">O</Option>
                  <Option value="AB">AB</Option>
                </Select>
                <ErrorMessage component="div" name="blood_type" className="gx-mt-2 gx-text-red" />
              </Item>
              <Item name="Status Kesehatan" required>
                <Row>
                  <Col md={12} xs={24}>
                    <Select
                      defaultValue={formik.values.health.status}
                      onChange={(value) => formik.setFieldValue('health.status', value)}
                      placeholder="Pilih status kesehatan"
                    >
                      {HEALTH_STATUS.map((item, key) => {
                        return (
                          <Option value={item.id} key={`health-status-${item.id}`}>
                            {item.label}
                          </Option>
                        );
                      })}
                    </Select>
                    <ErrorMessage
                      component="div"
                      name="health.status"
                      className="gx-mt-2 gx-text-red"
                    />
                  </Col>
                  <Col md={12} xs={24}>
                    <UploadButton onDone={(files) => formik.setFieldValue('health.file', files)} />
                  </Col>
                </Row>
              </Item>
              {formik.values.health.status === 3 ? (
                <Item name="Catatan Kesehatan">
                  <TextArea name="health.notes" onChange={formik.handleChange} />
                  <ErrorMessage
                    component="div"
                    name="health.notes"
                    className="gx-mt-2 gx-text-red"
                  />
                </Item>
              ) : null}
              <Item name="Departemen" required>
                <DepartmentForm />
              </Item>
              <Item name="Level Jabatan" required>
                <PositionForm />
              </Item>
              <Item name="Email" required>
                <Input name="email" onChange={formik.handleChange} />
                <ErrorMessage component="div" name="email" className="gx-mt-2 gx-text-red" />
              </Item>
              <Item name="HP" required>
                <Input name="phone" onChange={formik.handleChange} />
                <ErrorMessage component="div" name="phone" className="gx-mt-2 gx-text-red" />
              </Item>
              <Item name="Kontak Darurat" required>
                <Input name="emergency_contact" onChange={formik.handleChange} />
                <ErrorMessage
                  component="div"
                  name="emergency_contact"
                  className="gx-mt-2 gx-text-red"
                />
              </Item>
              <Item name="Pendidikan Terakhir" required>
                <EducationForm />
              </Item>
              <SkillsForm />

              <SicknessForm />

              <TrainingCompetencyForm />

              <JobSpecializationForm />
              {/* 
              <h3>Pengalaman Bekerja</h3>
              <Item name="Mulai Bekerja" required>
                <DatePicker
                  onChange={(value) => {
                    formik.setFieldValue('work_experience', value.format('YYYY-MM-DD'));
                  }}
                  disabledDate={(current) => {
                    return current && current > moment().endOf('day');
                  }}
                />
                <ErrorMessage
                  component="div"
                  name="work_experience"
                  className="gx-mt-2 gx-text-red"
                />
              </Item>
              <Item name="Lama Bekerja">
                <WorkingDuration date={formik.values.work_experience} />
              </Item> */}

              <h3>Riwayat pekerjaan sebelumnya (PP)</h3>
              <Item name="Mulai Bekerja" required>
                <DatePicker
                  value={formik.values.work_experience_pp_start_date ? moment(formik.values.work_experience_pp_start_date) : null}
                  onChange={(value) => {
                    formik.setFieldValue('work_experience_pp_start_date', value ? value.format('YYYY-MM-DD') : '');
                  }}
                  disabledDate={(current) => {
                    if (!current) return false;
                    return (
                      current > moment().endOf('day') ||
                      (formik.values.work_experience_pp_end_date &&
                        current > moment(formik.values.work_experience_pp_end_date).endOf('day'))
                    );
                  }}
                />
                <ErrorMessage
                  component="div"
                  name="work_experience_pp_start_date"
                  className="gx-mt-2 gx-text-red"
                />
              </Item>
              <Item name="Selesai Bekerja" required>
                <DatePicker
                  value={formik.values.work_experience_pp_end_date ? moment(formik.values.work_experience_pp_end_date) : null}
                  onChange={(value) => {
                    formik.setFieldValue('work_experience_pp_end_date', value ? value.format('YYYY-MM-DD') : '');
                  }}
                  disabledDate={(current) => {
                    if (!current) return false;
                    return (
                      current > moment().endOf('day') ||
                      (formik.values.work_experience_pp_start_date &&
                        current < moment(formik.values.work_experience_pp_start_date).startOf('day'))
                    );
                  }}
                />
                <ErrorMessage
                  component="div"
                  name="work_experience_pp_end_date"
                  className="gx-mt-2 gx-text-red"
                />
              </Item>
              <Item name="Lama Bekerja">
                <WorkingDuration
                  startDate={formik.values.work_experience_pp_start_date}
                  endDate={formik.values.work_experience_pp_end_date}
                />
              </Item>

              <h3>Riwayat pekerjaan sebelumnya (Non-PP)</h3>
              <Item name="Mulai Bekerja" required>
                <DatePicker
                  value={formik.values.work_experience_nonpp_start_date ? moment(formik.values.work_experience_nonpp_start_date) : null}
                  onChange={(value) => {
                    formik.setFieldValue('work_experience_nonpp_start_date', value ? value.format('YYYY-MM-DD') : '');
                  }}
                  disabledDate={(current) => {
                    if (!current) return false;
                    return (
                      current > moment().endOf('day') ||
                      (formik.values.work_experience_nonpp_end_date &&
                        current > moment(formik.values.work_experience_nonpp_end_date).endOf('day'))
                    );
                  }}
                />
                <ErrorMessage
                  component="div"
                  name="work_experience_nonpp_start_date"
                  className="gx-mt-2 gx-text-red"
                />
              </Item>
              <Item name="Selesai Bekerja" required>
                <DatePicker
                  value={formik.values.work_experience_nonpp_end_date ? moment(formik.values.work_experience_nonpp_end_date) : null}
                  onChange={(value) => {
                    formik.setFieldValue('work_experience_nonpp_end_date', value ? value.format('YYYY-MM-DD') : '');
                  }}
                  disabledDate={(current) => {
                    if (!current) return false;
                    return (
                      current > moment().endOf('day') ||
                      (formik.values.work_experience_nonpp_start_date &&
                        current < moment(formik.values.work_experience_nonpp_start_date).startOf('day'))
                    );
                  }}
                />
                <ErrorMessage
                  component="div"
                  name="work_experience_nonpp_end_date"
                  className="gx-mt-2 gx-text-red"
                />
              </Item>
              <Item name="Lama Bekerja">
                <WorkingDuration
                  startDate={formik.values.work_experience_nonpp_start_date}
                  endDate={formik.values.work_experience_nonpp_end_date}
                />
              </Item>

              <UploadSkillsFile />
            </Card>

            <ProjectForm />

            <div className="gx-mb-2 gx-mt-2">
              <span className="gx-text-red">*Wajib diisi oleh kandidat / pemohon</span>
            </div>

            <div className="gx-mb-5 gx-mt-2 gx-text-right">
              {hasFileError && (
                <span className="gx-text-red gx-mr-3" style={{ fontSize: 13, verticalAlign: 'middle' }}>
                  File sertifikat melebihi batas ukuran maksimal. Harap perbaiki sebelum menyimpan.
                </span>
              )}
              <Link to="/passport" className="ant-btn ant-btn-secondary gx-mb-0">
                Batal
              </Link>
              <Button
                type="primary"
                htmlType="submit"
                className="gx-mb-0"
                loading={formik.isSubmitting}
                disabled={formik.isSubmitting || hasFileError}
              >
                Simpan
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Create;

const WorkingDuration = ({startDate, endDate, date}) => {
  const start = startDate || date;
  if (!start) return null;
  const startMoment = moment(start);
  const endMoment = endDate ? moment(endDate) : moment();

  if (!startMoment.isValid() || !endMoment.isValid()) return null;

  const months = Math.floor(endMoment.diff(startMoment, 'months', true));
  if (months < 0) return null;
  const yearsCount = Math.floor(months / 12);
  const monthsCount = Math.floor(months % 12);

  return `${yearsCount ? `${yearsCount} Tahun ` : ``}${monthsCount} Bulan`;
};
